import {
  createPluginFactory,
  createPlugins,
  NoInfer as PlateNoInfer,
  PlatePlugin,
  PlatePluginComponent,
  PluginOptions,
  TNode,
} from '@udecode/plate-common';

import type {
  MyEditor,
  MyElement,
  MyOverrideByKey,
  MyPlatePlugin,
  MyValue,
} from './plateTypes';

export const createMyPluginFactory = <P = PluginOptions>(
  defaultPlugin: PlatePlugin<PlateNoInfer<P>, MyValue, MyEditor>,
): ReturnType<typeof createPluginFactory<P, MyValue, MyEditor>> =>
  createPluginFactory(defaultPlugin);

export const createMyPlugins = (
  plugins: MyPlatePlugin[],
  options?: {
    components?: Record<string, PlatePluginComponent>;
    overrideByKey?: MyOverrideByKey;
  },
  // @ts-expect-error Seems to be a type mismatch with createPlugins
): MyPlatePlugin[] => createPlugins<MyValue, MyEditor>(plugins, options);

export function isMyElement(node: TNode): node is MyElement {
  return 'id' in node && 'children' in node;
}
